<div class="container">
  <div class="text-container">
    <div class="title">How would you like to be contacted?</div>
    <p class="info-text">We will keep you up to date with new products and special offers <br /></p>
  </div>

  <div class="toggle-container">
    <div class="toggle-app">
      <dx-check-box name="groupname"
        class="chk-pad-right"
        [(value)]="allowAppNotifications">
      </dx-check-box>

      <div (click)="switchOptionsAppNotif()" class="toggle-title-container">
        <p class="toggle-title">App Notifications</p>
      </div>
    </div>

    <div class="toggle-app">
      <dx-check-box name="groupname"
        class="chk-pad-right"
        [(value)]="allowEmailNotifications">
      </dx-check-box>

      <div (click)="switchOptionsEmailNotif()" class="toggle-title-container">
        <p class="toggle-title">Email Notifications</p>
      </div>
    </div>

    <div class="toggle-app">
      <dx-check-box name="groupname"
        class="chk-pad-right"
        [(value)]="allowSMSNotifications">
      </dx-check-box>

      <div (click)="switchOptionsSmsNotif()" class="toggle-title-container">
        <p class="toggle-title">SMS Notifications</p>
      </div>
    </div>

  </div>
  <div class="text-container">
    <p class="info-text">We will SMS you for any regulatory information</p>
  </div>

  <button (click)="accept()" class="accept-btn">I accept</button>
</div>
